let utils = {
  getLang() {
    return this.lang;
  },

  t(lang, translation) {
    return this.translations[lang][translation];
  },

  getAttribute(attr) {
    if (attr == 'cur') return this.cur;
    if (attr == 'lang') return this.lang;
  },

  formatNumber(num, fraction_digits = 2, type=null) {
    let _locale = {
      'da': 'da-DK',
      'en': 'en-GB'
    }
    let division = (type) ? 1 : 100;
    return Number(num/division).toLocaleString(_locale[this.getLang], {minimumFractionDigits: fraction_digits});
  },

  checkObject(obj) {
    if (typeof obj == 'string') {
      return 0;
    }
  },

  showLang(lang) {
    if (lang == 'da') return '🇩🇰';
    if (lang == 'en') return '🇬🇧';
  },
  
  showCur(cur) {
    if (cur == 'dkk') return '🇩🇰';
    if (cur == 'eur') return '🇪🇺';
  },

  getWindowWidth() {
    const width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return width;
  
  },

  getWindowHeight() {
    const height = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;
    return height;
  },

  getTitle() {
    const localStorageData = localStorage.getItem(window.APP_API_CUSTOMER);
    if (!localStorageData) {
      return null;
    }
    const localStorageDataParsed = JSON.parse(localStorageData);
    if (!localStorageDataParsed.data.title) {
      return 'BAXX & METZ';
    }
    else {
      return `${localStorageDataParsed.data.title}`;
    }
  },
  
  setTitle() {
    const metaTitle = document.querySelector('head title');
    metaTitle.textContent = this.getTitle();
  },  

}

export default utils